import { create } from "zustand";

type ConnectionState = "connecting" | "connected" | "disconnected";

interface UiState {
  marketConnection: ConnectionState;
  tasksConnection: ConnectionState;
  apiLatencyMs: number | null;
  lastMarketUpdate: string | null;
  setMarketConnection: (state: ConnectionState) => void;
  setTasksConnection: (state: ConnectionState) => void;
  setApiLatencyMs: (value: number | null) => void;
  setLastMarketUpdate: (value: string | null) => void;
}

export const useUiStore = create<UiState>((set) => ({
  marketConnection: "connecting",
  tasksConnection: "connecting",
  apiLatencyMs: null,
  lastMarketUpdate: null,
  setMarketConnection: (marketConnection) => set({ marketConnection }),
  setTasksConnection: (tasksConnection) => set({ tasksConnection }),
  setApiLatencyMs: (apiLatencyMs) => set({ apiLatencyMs }),
  setLastMarketUpdate: (lastMarketUpdate) => set({ lastMarketUpdate }),
}));
